import React from "react";
import { Col, Row } from "antd";
import { css } from "@emotion/css";
import Wallet from "../../../Assets/Images/wallet.png";
import Deposit from "../../../Assets/Images/deposit.png";
import Playgame from "../../../Assets/Images/play-games.png";
import Affiliates from "../../../Assets/Images/affiliates.png";
import Promotion from "../../../Assets/Images/promotion.png";

function Footer() {
  const linkLogin = "https://gamev2.lsm99dna.live/";
  return (
    // <div className="bg-main-footer">
    //   <Row justify="center" align="middle" className={css`
    //           margin-right: 2rem
    //         }`}>
    //     <Col span={4}>
    //       <a href={linkLogin}>
    //         <img
    //           src={"https://assets.one-prod.com/web-assets/landingDna/Images/original-wallet.png"}
    //           className={css`width: 90%;
              
    //                     }`}
    //           alt="..."
    //         ></img>
    //       </a>
    //     </Col>
    //     <Col span={4}>
    //       <a href={linkLogin}>
    //         <img
    //           src={"https://assets.one-prod.com/web-assets/landingDna/Images/original-deposit.png"}
    //           className={css`width: 90%;
                    
             
    //                     }`}
    //           alt="..."
    //         ></img>
    //       </a>
    //     </Col>
    //     <Col span={6}>
    //       {" "}
    //       <a href={linkLogin}>
    //         <img
    //           src={"https://assets.one-prod.com/web-assets/landingDna/Images/original-play-games.png"}
    //           className={css`width: 90%;
    //                 margin-bottom: 25px;
    //                 margin-left: 10px; }
    //                     }`}
    //           alt="..."
    //         ></img>
    //       </a>
    //     </Col>
    //     <Col span={4}>
    //       <a href={linkLogin}>
    //         <img
    //           src={"https://assets.one-prod.com/web-assets/landingDna/Images/original-affiliates.png"}
    //           className={css`width: 90%;
    //                     }`}
    //           alt="..."
    //         ></img>
    //       </a>
    //     </Col>
    //     <Col span={4}>
    //       <a href="/promotion">
    //         <img
    //           src={"https://assets.one-prod.com/web-assets/landingDna/Images/original-promotion.png"}
    //           className={css`width: 90%;
    //                         }`}
    //           alt="..."
    //         ></img>
    //       </a>
    //     </Col>
    //   </Row>
    // </div>
    
		<div className='w-bottom-nav bg-main-footer'>
			<a href={linkLogin} className="nav-item" >
				<div className='nav-inner'>
					<img className='nav-image' src='https://assets.one-prod.com/web-assets/lsm99dna-next/images/menu/menu-wallet.png' width='80' alt="Wallet Icon" draggable='false' />
					{/* <img className='nav-image-active' src='https://assets.one-prod.com/web-assets/lsm99dna-next/images/menu/menu-wallet-active.gif' width='80' alt="Wallet Icon" draggable='false' /> */}
				</div>
				<p className='nav-text'>กระเป๋า</p>
			</a>

			<a href={linkLogin} className="nav-item">
				<div className='nav-inner'>
					<img className='nav-image' src='https://assets.one-prod.com/web-assets/lsm99dna-next/images/menu/menu-deposit.png' width='80' alt="Deposit Icon" draggable='false' />
					{/* <img className='nav-image-active' src='https://assets.one-prod.com/web-assets/lsm99dna-next/images/menu/menu-deposit-active.gif' width='80' alt="Deposit Icon" draggable='false' /> */}
				</div>
				<p className='nav-text'>ฝาก-ถอน</p>
			</a>

			<a href={linkLogin} className="nav-item nav-main">
				<div className='nav-inner'>
					<img className='nav-image' src='https://assets.one-prod.com/web-assets/lsm99dna-next/images/menu/menu-playgame-active.gif' width='80' alt="Playgame Icon" draggable='false' />
					{/* <img className='nav-image-active' src='https://assets.one-prod.com/web-assets/lsm99dna-next/images/menu/menu-playgame-active.gif' width='80' alt="Playgame Icon" draggable='false' /> */}
				</div>
				<p className='nav-text'>เล่นเกม</p>
			</a>

			<a href={linkLogin} className="nav-item">
				<div className='nav-inner'>
					<img className='nav-image' src='https://assets.one-prod.com/web-assets/lsm99dna-next/images/menu/menu-affiliate.png' width='80' alt="Affiliate Icon" draggable='false' />
					{/* <img className='nav-image-active' src='https://assets.one-prod.com/web-assets/lsm99dna-next/images/menu/menu-affiliate-active-2.gif' width='80' alt="Affiliate Icon" draggable='false' /> */}
				</div>
				<p className='nav-text'>เเนะนำเพื่อน</p>
			</a>

			<a href='/promotion' className="nav-item">
				<div className='nav-inner'>
					<img className='nav-image' src='https://assets.one-prod.com/web-assets/lsm99dna-next/images/menu/menu-promotion.png' width='80' alt="Promotion Icon" draggable='false' />
					{/* <img className='nav-image-active' src='https://assets.one-prod.com/web-assets/lsm99dna-next/images/menu/menu-promotion-active.gif' width='80' alt="Promotion Icon" draggable='false' /> */}
				</div>
				<p className='nav-text'>โปรโมชั่น</p>
			</a>
		</div>
  );
}

export default Footer;
